import React from 'react';
import { Field } from 'react-final-form';

import Text from 'components/common/form/Text';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import { required, maxLength, composeValidators } from 'utils/validators';

const FreeForm = () => (
    <div className="free-form">
        <Field
            name="result.body"
            component={Text}
            autoSize={{ minRows: 4, maxRows: 10 }}
            placeholder="placeholders.freeResult"
            validate={composeValidators(required, maxLength(20479))}
        />
    </div>
);

export default withAutoFocusForm(FreeForm);
